import { Grid, InputAdornment, Stack, Typography } from "@mui/material";
import { FormikDecimalTextField, FormikTextField } from "@shared";

import { SrvProceedingFormik } from "@/pages/clients/client/components/tabs/debt-settlement-tab/tabs/srv-proceeding-tab/SrvProceedingTab.types";
import {
  SRV_QUOTA_MAX,
  SRV_QUOTA_MIN,
} from "@/pages/clients/client/components/tabs/debt-settlement-tab/tabs/srv-proceeding-tab/SrvProceedingTab.utils";
import { useTranslation } from "@/translations";

interface Props {
  formik: SrvProceedingFormik;
}

export function QuotaCostsSection({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <Stack gap={3}>
      <Typography variant="h5">{t("clients.client.debtSettlement.srvProceeding.sections.quotaAndCosts")}</Typography>
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid size={6}>
          <FormikDecimalTextField
            formik={formik}
            path="offeredQuota"
            label={t("clients.client.debtSettlement.srvProceeding.fields.offeredQuota")}
            minValue={SRV_QUOTA_MIN}
            maxValue={SRV_QUOTA_MAX}
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>
        <Grid size={6}>
          <FormikDecimalTextField
            formik={formik}
            path="acceptedQuota"
            label={t("clients.client.debtSettlement.srvProceeding.fields.acceptedQuota")}
            minValue={SRV_QUOTA_MIN}
            maxValue={SRV_QUOTA_MAX}
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>
        <Grid size={6}>
          <FormikDecimalTextField
            formik={formik}
            path="proceedingCosts"
            label={t("clients.client.debtSettlement.srvProceeding.fields.proceedingCosts")}
            minValue={0}
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">€</InputAdornment>,
              },
            }}
          />
        </Grid>
        <Grid size={12}>
          <FormikTextField
            formik={formik}
            path="remark"
            label={t("clients.client.debtSettlement.srvProceeding.fields.remark")}
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
